__turbopack_context__.v({
  "button": "button-module-scss-module__4X8-va__button",
  "button--icon": "button-module-scss-module__4X8-va__button--icon",
  "button--icon--selected": "button-module-scss-module__4X8-va__button--icon--selected",
  "button--inverted": "button-module-scss-module__4X8-va__button--inverted",
  "button--plain": "button-module-scss-module__4X8-va__button--plain",
  "button--secondary": "button-module-scss-module__4X8-va__button--secondary",
  "button--small": "button-module-scss-module__4X8-va__button--small",
  "button--tertiary": "button-module-scss-module__4X8-va__button--tertiary",
  "button__prefix": "button-module-scss-module__4X8-va__button__prefix",
  "button__suffix": "button-module-scss-module__4X8-va__button__suffix",
});
